import { Route, Redirect, Switch } from "react-router-dom";
import { useRecoilValue } from "recoil";

import rootRedirectPathState from "../../states/rootRedirectPathState";

import MenuRedirector from "../functional/MenuRedirector";

import TkPopNoticeWrite from "../screens/TkPopNoticeWrite";
import TkPopNoticeUpdate from "../screens/TkPopNoticeUpdate";

function NewWindowRouter(props) {
    const rootRedirectPath = useRecoilValue(rootRedirectPathState);

    return (
        <>
            <Route exact path="/">
                <Redirect to={rootRedirectPath} />
            </Route>
            <MenuRedirector />
            <Switch>
                {/* Screens */}

                <Route path="*/TkPopNoticeCreateDialog/:workOrderNumber/:partNo" render={() => <TkPopNoticeWrite />} />
                <Route path="*/TkPopNoticeUpdateDialog/:workOrderNumber/:partNo" render={() => <TkPopNoticeUpdate />} />
                {/* Default Redirect */}

                <Route path="*">
                    <Redirect to="/" />
                </Route>
            </Switch>
        </>
    );
}

export default NewWindowRouter;
